module.exports = __webpack_public_path__ + "img/PYTHON.d331062c.png";